// extracted by mini-css-extract-plugin
export default {"active":"ColorSelector_active__4SbND"};